/*
  Export the configuration.
*/
export const IMPROVE_CONFIG = {
  API_URL: process.env.VUE_APP_API_URL,
  SERVERLESS_IMAGE_HANDLER: "https://d21qlfkuyb2o0k.cloudfront.net",
  BUCKET: process.env.VUE_APP_BUCKET,
  STRIPE: process.env.VUE_APP_STRIPE,
  DIRECT_URL: process.env.VUE_APP_DIRECT_URL,
  PARTNER_URL: process.env.VUE_APP_PARTNER_URL,
};
